// extracted by mini-css-extract-plugin
module.exports = {"ButtonContainer":"edit-moderated-news-modal_ButtonContainer__1IFcn","PublishButton":"edit-moderated-news-modal_PublishButton__u_Heb"};